<template>
	<div>
		<header v-if="device == 'true'">
			<div class="back" @click="goBack"><img src="../../../asset/back.png" alt=""></div>
		</header>
		<div class="welcome">欢迎登陆小白考研</div>
		<div v-if="qeihuan">
			<div class="codeBox">
				<div class="picCode">
					<input type="text" placeholder="请输入图形验证码" v-model="resultPicCode">
					<div class="get-code" @click="refreshCode">
						<img :src="picCode" alt="">
					</div>
				</div>
				<div class="telCode">
					<input type="text" placeholder="请输入验证码" v-model="resultNumCode">
					<p v-show="is_card">{{yzms}}</p>
					<p @click="getCode" v-show="!is_card">{{yzms}}</p>
				</div>
			</div>
			<div class="loginBtn" @click="login">登录</div>
			<div class="qeihuan" @click="qeihuan = false">密码登录</div>
		</div>
		<div class="kuan" v-else>
			<div class="codeBox">
				<div class="picCode">
					<input type="text" placeholder="请输入手机号" v-model="username">
				</div>
				<div class="telCode">
					<input type="password" placeholder="请输入密码" v-model="password">
				</div>
			</div>
			<div class="loginBtn" @click="login2">登录</div>
			<div class="qeihuan" @click="qeihuan = true">验证码登录</div>
		</div>
		
		
		
		
		
	</div>
</template>

<script>
	import https from '../../../https'
	import {
		Toast
	} from 'vant';
	export default {

		data() {
			return {
				qeihuan:true,
				yzms: "获取验证码",
				is_card: false,
				i: 60,
				picCode: '',
				resultPicCode: '',
				resultNumCode:'',
				tel:'',
				
				username:"",
				password:"",
				device:"true"
			}
		},
		created() {
			this.getPicCode()
			this.username = this.$route.query.tel;
			console.log( typeof this.$route.query.qeihuan,this.$route.query.qeihuan == "false")
			if(this.$route.query.qeihuan == "false"){
				this.qeihuan = false;
			}
			if(this.$route.query.qeihuan == false){
				this.qeihuan = false;
			}
			var storage = window.sessionStorage;
			var device = storage.getItem('device')
			this.route = this.$route.query.route;
			console.log("route",this.route)
      
			if(device){
				this.device = device
			}
		},
		mounted() {
			// console.log(this.$route.query.userid)
			this.tel = this.$route.query.tel
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			refreshCode(){
				this.getPicCode()
			},
			getPicCode() {
				var token = new Date().getTime()
				// var token = this.$route.query.token
				console.log(token)
				var storage = window.sessionStorage;
				storage.setItem('token', token);
				this.picCode = https.api+`/api/getVerificationCodeImg?token=${token}`
			},
			getCode() { //获取验证码
				//验证码发送
				if (this.resultPicCode == '') {
					Toast.loading({
						message: '图片验证码无效',
						forbidClick: true,
					})
				} else {
					var storage = window.sessionStorage;
					// console.log(storage.getItem('token'))
					var token = storage.getItem('token')
					console.log(token)
					var resultCode = this.resultPicCode
					var param ={
						token:token,
						resultCode:resultCode
					}
					var tel = this.tel
					
					https.fetchGet(
					// https://dev.kypro.ikaoyaner.com/api/login/sendSMS/18513639949?token=${token}&resultCode=${resultCode}
						// `/api/login/sendSMS/${tel}?token=${token}&resultCode=${resultCode}`).then(
						'/api/login/sendSMS/'+this.tel,param).then(
						res => {
							console.log(res,"123")
							if(res.data.code == 200){
								this.is_card = true;
								let time = window.setInterval(() => {
									this.yzms = "(" + (this.i--) + ")秒后重新发送";
									if (this.i == -1) {
										window.clearInterval(time);
										this.is_card = false;
										this.yzms = "获取验证码";
										this.i = 60;
									}
								}, 1000)
							}else{
								Toast.loading({
									message: res.data.msg,
									forbidClick: true,
								})
							}
							console.log(res)

						}).catch(err => {

						Notify({
							type: 'warning',
							message: '当前人数过多，请稍后重试'
						});

					})
				}
			},
			login2(){
				var client_id = "app";
				var client_secret = "app_secure";
				var grant_type = "password";
				var username = this.username;
				var loginWay = "2";
				var password = this.password;
				https.fetchPost(
					`/api/oauth/token?client_id=${client_id}&client_secret=${client_secret}&grant_type=${grant_type}&username=${username}&loginWay=${loginWay}&password=${password}`).then(
					res => {
						console.log(res)
						if(res.data.access_token){
							var storage = window.sessionStorage;
							storage.setItem('token', res.data.access_token);
							storage.setItem('LoginStatus', true);
							storage.setItem('open', true);
							this.$router.push({	
								name:this.route,
								query:{
									token:res.data.access_token
								}
							})
						}else{
							Notify({
								type: 'warning',
								message: '登录失败，请重新登录'
							})
						}
				
					}).catch(err => {
					console.log(err.response)
					var response = err.response;
					var data = response.data
					var error = data.error
					if(error == "unauthorized"){
						Toast.loading({
							message: "您尚未设置密码，建议切换到验证码登录哦",
							forbidClick: true,
						})
					}else if(error == "invalid_grant"){
						Toast.loading({
							message: "密码错误",
							forbidClick: true,
						})
					}
					
					
					
					// Notify({
					// 	type: 'warning',
					// 	message: '当前人数过多，请稍后重试'
					// });
				
				})
			},
			login(){
				var client_id = 'app'
				var client_secret = 'app_secure'
				var grant_type = 'password'
				var username = this.tel
				var loginWay = '1'
				var password = this.resultNumCode
				https.fetchPost(
					`/api/oauth/token?client_id=${client_id}&client_secret=${client_secret}&grant_type=${grant_type}&username=${username}&loginWay=${loginWay}&password=${password}`).then(
					res => {
						// console.log(res.data.access_token)
						if(res.data.access_token){
							var storage = window.sessionStorage;
							storage.setItem('token', res.data.access_token);
							storage.setItem('LoginStatus', true);
							storage.setItem('open', true);
							this.$router.push({
								name:this.route,
								query:{
									token:res.data.access_token
								}
							})
						}else{
							Notify({
								type: 'warning',
								message: '登录失败，请重新登录'
							})
						}
				
					}).catch(err => {
					console.log(err)
					console.log(err.response)
					var response = err.response;
					var data = response.data
					var error = data.error
					if(error == "invalid_grant"){
						// Toast.loading({
						// 	message: "您尚未设置密码，建议切换到验证码登录哦",
						// 	forbidClick: true,
						// })
					}else if(error == "invalid_grant"){
						Toast.loading({
							message: "验证码错误",
							forbidClick: true,
						})
					}
					// Notify({
					// 	type: 'warning',
					// 	message: '当前人数过多，请稍后重试'
					// });
				
				})
			}
		},
		watch: {
			resultPicCode() {},
			resultNumCode(){}
		},
	}
</script>

<style scoped="scoped">
	.qeihuan{
		font-size: 30px;
		text-align: center;
		line-height: 30px;
		margin-top: 20px;
		padding: 20px;
	}
	.kuan input{
		width: 100% !important;
	}
	input::-webkit-input-placeholder {

		font-size: 34px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #AAAAAA;
		line-height: 30px;
	}

	header {
		width: 750px;
		height: 88px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		background: #FFFFFF;
	}

	.back {
		width: 28px;
		height: 28px;
		margin-left: 30px;
	}

	.back img {
		width: 100%;
	}

	.welcome {
		width: 606px;
		margin: 0 auto;
		font-size: 50px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 48px;
		padding: 86px 0 0 0;
	}

	.codeBox {
		width: 606px;
		margin: 102px auto 0 auto;
	}

	.codeBox .picCode,
	.codeBox .telCode {
		display: flex;
		border-bottom: 1px solid #D7D7D7;
		justify-content: space-between;
		height: 105px;
	}

	.codeBox .picCode input,
	.codeBox .telCode input {
		outline: none;
		border: none;
		width: 240px;
		background-color: rgba(0,0,0,0);
	}

	.codeBox .picCode .get-code {
		width: 150px;
		height: 70px;
		margin: 10px;
		margin-bottom: 30px;
	}

	.codeBox .picCode .get-code img {
		width: 150px;
		height: 70px;
	}

	.codeBox .telCode {
		margin-top: 30px;
	}

	.codeBox .telCode p {
		font-size: 34px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #3F94FF;
		line-height: 30px;
	}

	.loginBtn {
		width: 607px;
		height: 88px;
		background: #3F94FF;
		border-radius: 44px;
		font-size: 30px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 42px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 132px auto 0 auto;
	}
</style>
